/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A navigation solution for VDK Web. (@accedo/vdkweb-navigation) 6.2.5
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));
var _uiImplementationHelpers = require("../uiImplementationHelpers");
var _navigationService = _interopRequireDefault(require("../navigationService"));
var _focusManager = _interopRequireDefault(require("../focusManager"));
var _excluded = ["onClick"],
  _excluded2 = ["nav"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/state-in-constructor */
var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && typeof Component.prototype.render === 'function');
};
var areObjShallowDifferent = function areObjShallowDifferent() {
  var objA = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var objB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var propsToExclude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  return keysA.length !== keysB.length ? true : keysA.some(function (keyInA) {
    return propsToExclude[keyInA] ? false : objA[keyInA] !== objB[keyInA];
  });
};
var withFocusPropTypes = {
  directionReassign: _propTypes["default"].object,
  nav: _propTypes["default"].object,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onFocus: _propTypes["default"].func
};
var withFocus = function withFocus(WrappedComponent) {
  var isClassComponentVal = isClassComponent(WrappedComponent);
  var Focus = /*#__PURE__*/function (_React$Component) {
    _inherits(Focus, _React$Component);
    var _super = _createSuper(Focus);
    function Focus() {
      var _this;
      _classCallCheck(this, Focus);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "state", {});
      _defineProperty(_assertThisInitialized(_this), "setLastFocus", function (value) {
        _this.lastFocus = value;
      });
      _defineProperty(_assertThisInitialized(_this), "getLastFocus", function () {
        return _this.lastFocus;
      });
      _defineProperty(_assertThisInitialized(_this), "onUpdate", function () {
        return _this.mounted && _this.forceUpdate();
      });
      _defineProperty(_assertThisInitialized(_this), "onClick", function () {
        var _assertThisInitialize = _assertThisInitialized(_this),
          component = _assertThisInitialize.component;
        if (component) {
          var clickNode = component.clickNode;
          if (clickNode) {
            clickNode.click();
            return true;
          }
        } else {
          var _this$props = _this.props,
            onClick = _this$props.onClick,
            rest = _objectWithoutProperties(_this$props, _excluded);
          if (onClick) {
            onClick(rest);
          }
        }
        return false;
      });
      _defineProperty(_assertThisInitialized(_this), "handleNavigationUpdate", function (newData, prevData) {
        var _this$props2 = _this.props,
          nav = _this$props2.nav,
          onFocus = _this$props2.onFocus,
          onBlur = _this$props2.onBlur,
          directionReassign = _this$props2.directionReassign;
        (0, _uiImplementationHelpers.handleNavigationUpdate)({
          directionReassign: directionReassign,
          getLastFocus: _this.getLastFocus,
          nav: nav,
          newData: newData,
          onBlur: onBlur,
          onClick: _this.onClick,
          onFocus: onFocus,
          onUpdate: _this.onUpdate,
          prevData: prevData,
          setLastFocus: _this.setLastFocus
        });
      });
      _defineProperty(_assertThisInitialized(_this), "handleMouseOver", function () {
        _focusManager["default"].changeFocus(_this.props.nav.id);
      });
      _defineProperty(_assertThisInitialized(_this), "handleMouseOut", function () {
        _focusManager["default"].changeFocus('');
      });
      _defineProperty(_assertThisInitialized(_this), "setClassRef", function (c) {
        _this.component = c;
      });
      return _this;
    }
    _createClass(Focus, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.mounted = true;
        var nav = this.props.nav;
        if (nav.id) {
          _navigationService["default"].listenToFocusEvent({
            id: nav.id,
            fn: this.handleNavigationUpdate
          });
        }
        (0, _uiImplementationHelpers.forwardFocusIfNecessary)({
          nav: nav,
          lastFocus: this.lastFocus
        });
      }
    }, {
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(prevProps) {
        return areObjShallowDifferent(this.props, prevProps, {
          nav: true
        }) || areObjShallowDifferent(this.props.nav, prevProps.nav);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var nav = this.props.nav;
        if (prevProps.nav.id !== nav.id) {
          if (prevProps.nav.id) {
            _navigationService["default"].unlistenToFocusEvent({
              id: prevProps.nav.id,
              fn: this.handleNavigationUpdate
            });
          }
          if (nav.id) {
            _navigationService["default"].listenToFocusEvent({
              id: nav.id,
              fn: this.handleNavigationUpdate
            });
          }
        }
        (0, _uiImplementationHelpers.forwardFocusIfNecessary)({
          lastFocus: this.lastFocus,
          nav: nav,
          prevNav: prevProps.nav
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.mounted = false;
        if (this.props.nav.id) {
          _navigationService["default"].unlistenToFocusEvent({
            id: this.props.nav.id,
            fn: this.handleNavigationUpdate
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
          nav = _this$props3.nav,
          otherProps = _objectWithoutProperties(_this$props3, _excluded2);
        var isFocused = (0, _uiImplementationHelpers.getIsFocused)({
          nav: nav
        });
        var newNav = (0, _immutabilityHelper["default"])(nav, {
          $merge: {
            isFocused: isFocused,
            onMouseOver: this.handleMouseOver,
            onMouseOut: this.handleMouseOut
          }
        });
        var props = _objectSpread(_objectSpread({}, otherProps), {}, {
          isFocused: isFocused,
          nav: newNav
        });
        if (isClassComponentVal) {
          props.ref = this.setClassRef;
        }
        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, props);
      }
    }]);
    return Focus;
  }(_react["default"].Component);
  Focus.defaultProps = {
    nav: {}
  };
  Focus.propTypes = withFocusPropTypes;
  return Focus;
};
var _default = withFocus;
exports["default"] = _default;